/* eslint-disable tailwindcss/no-custom-classname */
import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { ON_DEMAND, SAME_DAY } from '../../helpers/constants';
import { capitalizeFirstLetter } from '../../helpers/utils';

const getDeliveryCharge = (option) => {
  if (option?.totalCharge) {
    return <span className="sui-text">${option?.totalCharge}</span>;
  }
  return option?.totalCharge === 0 ? <span className="sui-text-success">Free</span> : <span />;
};

const getTimelineText = (option) => {
  const type = option?.type;
  if (type === ON_DEMAND) {
    return `Within ${option?.timeline}`;
  }
  if (type === SAME_DAY) {
    const timeline = option?.timeline;
    const capitalizedTimeline = timeline?.toLowerCase() === 'today'
      ? capitalizeFirstLetter(timeline.toLowerCase())
      : timeline;
    return `${capitalizedTimeline}*`;
  }
  return option?.timeline;
};

const PriorityOption = ({ option }) => {
  return (
    <div className="sui-pb-5">
      <Typography variant="body-lg" height="normal">
        <div className="sui-grid sui-grid-cols-12">
          <div className="sui-col-span-10 sui-pb-1">
            {'Get it '}
            <span className="sui-font-bold">{getTimelineText(option)}</span>
          </div>
          <div className="sui-col-span-2 sui-text-end sui-font-bold">
            {getDeliveryCharge(option)}
          </div>
        </div>
      </Typography>
    </div>
  );
};

export const PriorityDeliveryOptions = ({
  priorityDeliveryOptions = []
}) => {
  const onDemand = priorityDeliveryOptions?.find((option) => option?.type === ON_DEMAND);
  const sameDay = priorityDeliveryOptions?.find((option) => option?.type === SAME_DAY);

  return (
    <div data-testid="priority-delivery-options">
      {onDemand && <PriorityOption option={onDemand} />}
      {sameDay && <PriorityOption option={sameDay} />}
    </div>
  );
};